import { OrderQuoteParams, SetOrderQuoteParamsForInstrument } from '../constants/order'
import useOrderParams from './useOrderParams'
import useOrderParamsStateForInstrument from './useOrderParamsStateForInstrument'

export default function useOrderParamsForInstrument(
  instrumentName: string,
  initialOrderParams?: OrderQuoteParams
): [OrderQuoteParams, SetOrderQuoteParamsForInstrument] {
  const [orderParamsNullable, setOrderParamsNullable] = useOrderParams(initialOrderParams)

  return useOrderParamsStateForInstrument(
    instrumentName,
    orderParamsNullable,
    setOrderParamsNullable
  )
}
